import React from 'react';
import HerosContainer from './heros_container';

const App = () => {
  return (
    <div>
      <HerosContainer />
    </div>
  )
}

export default App;



// WEBPACK FOOTER //
// ./frontend/components/app.jsx